import { emitFunnelEvent } from '@/shared/infra/telemetry'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { EmitFunnelEvent } from '@/shared/domain'

export function makeEmitFunnelEvent(source?: string): EmitFunnelEvent {
  const httpClient = makeSupabaseEdgeHttpClient()
  return (params) => {
    void emitFunnelEvent({ ...params, source: params.source ?? source, httpClient })
  }
}
